import FormField from "../FormField";
import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import "./styles.scss";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import { CircularProgress } from "@mui/material";

/**
 *
 * @param fields
 * [
 * {id: 'name', title: 'Name', type: 'text', value: 'Text'},
 * {id: 'users', title: 'Users', type: 'list || user', multiple: true,
                items: [{value: 1572, text: 'Ir Sk'},{value: 1, text: 'Roman'}],
                value: [1572, 1]
 * ]
 * @param tabs
 * @param onSubmitHandler
 * @param submitResult
 * {error: '...'} or {success: '...'}
 * @param title
 * @param btnText
 * @param translitFields {from: 'title', to: "code"}
 * @returns {*}
 * @constructor
 */

function FormDetail({
  fields,
  tabs = null,
  onSubmitHandler = () => {},
  submitResult = {},
  title = "",
  btnText = "",
  translitFields = null,
  onTabChange = () => {},
}) {
  const [values, setValues] = useState({});
  const [empty, setEmpty] = useState([]);
  const [hideBtn, setHideBtn] = useState(false);
  const [newValue, setNewValue] = useState({});

  const changeHandler = (params) => {
    setVal(params).then(() => {
      validate();
    });
  };

  const setVal = async (params) => {
    if (!values[params.code]) {
      values[params.code] = params.value;
      await setValues(values);
    } else {
      let val = Object.assign(values);
      val[params.code] = params.value;
      await setValues(val);
    }
  };

  // useEffect(()=>{
  //     console.log(values, 'validate')
  //     // validate()
  // },[values])

  const [loading, setLoading] = useState(false);
  const submitHandler = () => {
    if (validate()) {
      onSubmitHandler(values);
      setLoading(true);
    }
  };

  useEffect(() => {
    if (submitResult) {
      setLoading(false);
    }
  }, [submitResult]);

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    onTabChange(event, newValue);
  };

  const validate = () => {
    let items = fields;
    if (tabs) {
      items = [];
      tabs.forEach((tab) => {
        if (tab.fields) {
          items = items.concat(tab.fields);
        }
      });
    }

    let requireds = items.filter((item) => item.required);

    let errors = [];
    requireds.forEach((item) => {
      let val = values[item.id];

      if (isEmptyValue(val)) {
        let f = items.find((el) => el.id === item.id);

        if (f.dependence && !f.dependenceValues?.includes(values[f.dependence]))
          return;

        if (isEmptyValue(val)) {
          errors.push(item.id);
        }
      }
    });
    setEmpty(errors);
    return errors.length === 0;
  };

  const isEmptyValue = (val) => {
    return (
      !val ||
      (Array.isArray(val) && !val.length) ||
      (typeof val === "object" && !Object.keys(val).length)
    );
  };

  const onTabClickHandler = (tab) => {
    setHideBtn(!!tab.independent);
  };

  const getNonEditableValue = useCallback((field) => {
    let value = field.value;
    switch (field.type) {
      case "image":
        if (!field.multiple) {
          field.value = [field.value];
        }
        value = (
          <div className="attach-value">
            {field.value.map((image, index) => (
              <a href={image.url} target="blank">
                <img key={index} src={image.url} alt="attach" />
              </a>
            ))}
          </div>
        );
        break;
      case "html":
        value = <span dangerouslySetInnerHTML={{ __html: value }} />;
        break;
      default:
        break;
    }
    return value;
  }, []);

  return (
    <Paper className="detail-form">
      {!!title && <h2>{title}</h2>}
      {!!fields && (
        <>
          {fields.map((field) => (
            <div key={field.id}>
              {field.non_editable && (
                <div style={{ marginBottom: "10px" }}>
                  <div>
                    <b>{field.title}:</b>
                  </div>
                  <div>{getNonEditableValue(field)}</div>
                </div>
              )}
              {!field.non_editable && (
                <FormField
                  newValue={newValue[field.id]}
                  isEmpty={empty.includes(field.id)}
                  key={field.id}
                  field={field}
                  onHandleChange={changeHandler}
                  dependenceValueIsSet={field.dependenceValues?.includes(
                    values[field.dependence],
                  )}
                  dependenceTitle={
                    field.dependenceTitles &&
                    typeof values[field.dependence] == "string"
                      ? (field.dependenceTitles[values[field.dependence]] ?? "")
                      : ""
                  }
                />
              )}
            </div>
          ))}
        </>
      )}

      {!!tabs && (
        <>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="basic tabs"
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    label={tab.title}
                    onClick={() => onTabClickHandler(tab)}
                    {...a11yProps(index)}
                  />
                ))}
              </Tabs>
            </Box>
            {tabs.map((tab, index) => (
              <TabPanel key={index} value={tabValue} index={index}>
                {!!tab.fields && (
                  <>
                    {tab.fields.map((field) => (
                      <FormField
                        newValue={newValue[field.id]}
                        isEmpty={empty.includes(field.id)}
                        key={field.id}
                        field={field}
                        onHandleChange={changeHandler}
                        dependenceValueIsSet={field.dependenceValues?.includes(
                          values[field.dependence],
                        )}
                        dependenceTitle={
                          field.dependenceTitles &&
                          typeof values[field.dependence] == "string"
                            ? (field.dependenceTitles[
                                values[field.dependence]
                              ] ?? "")
                            : ""
                        }
                      />
                    ))}
                  </>
                )}

                {!!tab.content && tab.content}
              </TabPanel>
            ))}
          </Box>
        </>
      )}

      <div style={{ clear: "both" }}></div>
      {!!submitResult.success && (
        <Alert severity="success">Item is successfully updated!</Alert>
      )}
      {!!submitResult.error && (
        <Alert severity="error">{submitResult.error}</Alert>
      )}
      {!!loading && (
        <div className="text-center">
          <CircularProgress />
        </div>
      )}
      <div className="detail-form__send-btn-wrap text-center">
        {!hideBtn && (
          <Button
            disabled={empty.length > 0}
            className="detail-form__send-btn"
            onClick={() => submitHandler()}
            variant="contained"
            size="medium"
          >
            {btnText || "Save"}
          </Button>
        )}
      </div>
    </Paper>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <div className={value !== index ? "hidden" : ""}>{children}</div>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default FormDetail;
